/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sg_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How are accents and symbols handled?`)
};

const es_sg_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo se manejan los acentos y símbolos?`)
};

const de_sg_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie werden Akzente und Symbole behandelt?`)
};

const nl_sg_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe worden accenten en symbolen behandeld?`)
};

const fr_sg_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment les accents et les symboles sont-ils traités ?`)
};

const it_sg_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come vengono gestiti gli accenti e i simboli?`)
};

const pt_br2_sg_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como são tratados acentos e símbolos?`)
};

const pt_sg_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como são tratados acentos e símbolos?`)
};

const ja_sg_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクセント記号と記号はどのように処理されますか?`)
};

const zh_sg_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重音符号和特殊字符是如何处理的？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sg_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sg_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sg_faq2_q", locale)
	if (locale === "en") return en_sg_faq2_q(inputs)
	if (locale === "es") return es_sg_faq2_q(inputs)
	if (locale === "de") return de_sg_faq2_q(inputs)
	if (locale === "nl") return nl_sg_faq2_q(inputs)
	if (locale === "fr") return fr_sg_faq2_q(inputs)
	if (locale === "it") return it_sg_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_sg_faq2_q(inputs)
	if (locale === "pt") return pt_sg_faq2_q(inputs)
	if (locale === "ja") return ja_sg_faq2_q(inputs)
	return zh_sg_faq2_q(inputs)
};